<div class="aic-one-console">
  <Navbar />
  <div class="page-wrapper">
    <Sidebar />
    <div class="hero-section w-100 soft-card">
      <div class="dashboard-shell">
        <div class="dashboard-shell-body">
          <ul class="nav nav-tabs dashboard-tabs" role="tablist" aria-label="Indigent dashboards">
            <li class="nav-item" role="presentation">
              <button
                class="nav-link"
                :class="{ active: active_tab === 'management' }"
                type="button"
                role="tab"
                :aria-selected="active_tab === 'management'"
                @click="switch_tab('management')"
              >
                Indigent Management
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button
                class="nav-link"
                :class="{ active: active_tab === 'onboarding' }"
                type="button"
                role="tab"
                :aria-selected="active_tab === 'onboarding'"
                @click="switch_tab('onboarding')"
              >
                Indigent Onboarding
              </button>
            </li>
          </ul>
          <div class="superset-host">
            <div v-if="loading" class="superset-loading d-flex flex-column align-items-center justify-content-center">
              <div class="spinner-border text-dark mb-3" role="status"></div>
              <div class="text-muted small">Loading dashboard...</div>
            </div>
            <div v-if="error_message" class="superset-error d-flex align-items-center justify-content-center text-center p-4">
              <div>
                <i class="fa-solid fa-circle-exclamation fa-2x text-danger mb-3"></i>
                <div class="fw-semibold mb-2">Dashboard failed to load</div>
                <div class="text-muted small">{{ error_message }}</div>
              </div>
            </div>
            <div ref="superset_mount" class="superset-mount"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<PoweredBy />
